/* eslint-disable max-len,react/jsx-tag-spacing */
import React from 'react';
import classNames from 'classnames';
import css from './Icon.module.scss';

interface Props {
  type: string;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
  onClick?: (event: React.MouseEvent) => void;
}

const Icon = ({ type, className, width, height, color, secondaryColor, onClick, ...iconProps }: Props) => {
  let icon = null;
  const svgProps = {
    width,
    height,
    viewBox: `0 0 ${width || 38} ${height || 38}`,
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (type) {
    case 'redArrowDown': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.115 12.538">
          <path
            id="down_red_arrow"
            data-name="down red_arrow"
            d="M16.191,19.235l7.562-7.568a1.423,1.423,0,0,1,2.019,0,1.441,1.441,0,0,1,0,2.025L17.2,22.265a1.427,1.427,0,0,1-1.971.042L6.6,13.7a1.429,1.429,0,0,1,2.019-2.025Z"
            transform="translate(-5.688 -10.746)"
            fill="#ed1c24"
            stroke="#fff"
            strokeWidth="1"
          />
        </svg>
      );
      break;
    }

    case 'plusIcon': {
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          fill="currentColor"
          className="bi bi-plus"
          viewBox="0 0 16 16"
        >
          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg>
      );
      break;
    }
    case 'redArrowUp': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.115 12.538">
          <path
            id="up_red_arrow"
            d="M16.191,14.694l7.562,7.568a1.423,1.423,0,0,0,2.019,0,1.441,1.441,0,0,0,0-2.025L17.2,11.663a1.427,1.427,0,0,0-1.971-.042L6.6,20.231a1.429,1.429,0,0,0,2.019,2.025Z"
            transform="translate(-5.688 -10.644)"
            fill="#ed1c24"
            stroke="#fff"
            strokeWidth="1"
          />
        </svg>
      );
      break;
    }

    case 'friends': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 23 23">
          <g id="frinds" transform="translate(-920 -721)">
            <path
              id="icon_frind"
              d="M11.5,0A11.5,11.5,0,1,1,0,11.5,11.5,11.5,0,0,1,11.5,0Z"
              transform="translate(920 721)"
              fill="#db181f"
            />
            <path
              id="Icon_metro-user"
              data-name="Icon metro-user"
              d="M11.9,14.151v-.763a4.133,4.133,0,0,0,1.851-3.439c0-2.3,0-4.164-2.776-4.164S8.2,7.649,8.2,9.948a4.133,4.133,0,0,0,1.851,3.439v.763c-3.139.257-5.552,1.8-5.552,3.664H17.454c0-1.865-2.413-3.407-5.552-3.664Z"
              transform="translate(920.501 720.186)"
              fill="#fff"
            />
          </g>
        </svg>
      );
      break;
    }

    case 'whatsapp': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.662 21.662">
          <g id="whatsapp" transform="translate(1 1)">
            <g id="wt" transform="translate(-14248.999 -6971)" fill="none">
              <path
                d="M14249,6980.829a9.831,9.831,0,1,1,9.829,9.833A9.83,9.83,0,0,1,14249,6980.829Zm4.154-.163a5.874,5.874,0,0,0,.787,2.942l-.835,3.047,3.119-.819a5.9,5.9,0,0,0,2.811.718h0a5.884,5.884,0,1,0-5.885-5.889Zm5.882,4.894a4.892,4.892,0,0,1-2.488-.681l-.177-.106-1.854.485.5-1.8-.117-.185a4.89,4.89,0,1,1,4.143,2.291Zm-2.472-7.423a1.639,1.639,0,0,0-.515,1.224,2.87,2.87,0,0,0,.6,1.522,6.6,6.6,0,0,0,2.512,2.217,8.352,8.352,0,0,0,.837.31,1.987,1.987,0,0,0,.928.058,1.51,1.51,0,0,0,.991-.7,1.223,1.223,0,0,0,.085-.7c-.036-.061-.133-.1-.28-.171s-.871-.43-1-.479-.234-.075-.33.073-.381.478-.464.577-.174.11-.321.035a4.007,4.007,0,0,1-1.182-.729,4.445,4.445,0,0,1-.819-1.017c-.083-.148,0-.221.066-.3a4.321,4.321,0,0,0,.367-.5.275.275,0,0,0-.013-.258c-.035-.072-.33-.794-.454-1.089-.1-.253-.214-.253-.3-.253h-.031c-.086,0-.184,0-.282,0A.537.537,0,0,0,14256.563,6978.137Z"
                stroke="none"
              />
              <path
                d="M 14258.828125 6970.99951171875 C 14253.400390625 6970.99951171875 14248.9990234375 6975.4013671875 14248.9990234375 6980.8291015625 C 14248.9990234375 6986.2578125 14253.400390625 6990.66162109375 14258.828125 6990.66162109375 C 14264.2587890625 6990.66162109375 14268.6611328125 6986.2578125 14268.6611328125 6980.8291015625 C 14268.6611328125 6975.4013671875 14264.2587890625 6970.99951171875 14258.828125 6970.99951171875 M 14259.0380859375 6986.55517578125 L 14259.03515625 6986.55517578125 C 14258.0517578125 6986.552734375 14257.08203125 6986.30615234375 14256.224609375 6985.83740234375 L 14253.10546875 6986.65625 L 14253.9404296875 6983.60888671875 C 14253.4248046875 6982.716796875 14253.1533203125 6981.70361328125 14253.1533203125 6980.66650390625 C 14253.15625 6977.42529296875 14255.794921875 6974.787109375 14259.0380859375 6974.787109375 C 14260.611328125 6974.787109375 14262.08984375 6975.39892578125 14263.2001953125 6976.51123046875 C 14264.3125 6977.623046875 14264.9208984375 6979.10107421875 14264.9208984375 6980.6728515625 C 14264.919921875 6983.91455078125 14262.2822265625 6986.55517578125 14259.0380859375 6986.55517578125 M 14259.0400390625 6975.77978515625 C 14256.3427734375 6975.77978515625 14254.1484375 6977.97314453125 14254.1474609375 6980.66845703125 C 14254.1474609375 6981.59130859375 14254.4072265625 6982.49169921875 14254.8955078125 6983.26953125 L 14255.0126953125 6983.45458984375 L 14254.5166015625 6985.2578125 L 14256.3701171875 6984.77294921875 L 14256.546875 6984.87939453125 C 14257.2978515625 6985.32373046875 14258.1591796875 6985.56005859375 14259.03515625 6985.56005859375 L 14259.0380859375 6985.56005859375 C 14261.732421875 6985.56005859375 14263.92578125 6983.36669921875 14263.927734375 6980.67138671875 C 14263.927734375 6979.36474609375 14263.419921875 6978.13671875 14262.4970703125 6977.21435546875 C 14261.5751953125 6976.2890625 14260.345703125 6975.77978515625 14259.0400390625 6975.77978515625 M 14259.76171875 6982.15478515625 C 14259.8232421875 6982.15478515625 14259.8720703125 6982.12646484375 14259.921875 6982.0712890625 C 14260.0048828125 6981.97265625 14260.287109375 6981.642578125 14260.3857421875 6981.49462890625 C 14260.48046875 6981.34716796875 14260.5810546875 6981.37158203125 14260.7158203125 6981.421875 C 14260.849609375 6981.47021484375 14261.5751953125 6981.8251953125 14261.720703125 6981.900390625 C 14261.8681640625 6981.97265625 14261.96484375 6982.01025390625 14262.0009765625 6982.0712890625 C 14262.0380859375 6982.13330078125 14262.0380859375 6982.42578125 14261.916015625 6982.76953125 C 14261.7939453125 6983.11279296875 14261.20703125 6983.42578125 14260.9248046875 6983.4677734375 C 14260.671875 6983.5078125 14260.3505859375 6983.5224609375 14259.9970703125 6983.41015625 C 14259.783203125 6983.34228515625 14259.5107421875 6983.251953125 14259.16015625 6983.10009765625 C 14257.6865234375 6982.4638671875 14256.724609375 6980.9794921875 14256.6484375 6980.8828125 C 14256.5751953125 6980.783203125 14256.048828125 6980.08544921875 14256.048828125 6979.36083984375 C 14256.048828125 6978.638671875 14256.4287109375 6978.28125 14256.5634765625 6978.13671875 C 14256.697265625 6977.98828125 14256.8583984375 6977.95166015625 14256.9541015625 6977.95166015625 C 14257.052734375 6977.95166015625 14257.150390625 6977.95166015625 14257.236328125 6977.9560546875 C 14257.2451171875 6977.9560546875 14257.2568359375 6977.9560546875 14257.267578125 6977.9560546875 C 14257.3525390625 6977.9560546875 14257.4619140625 6977.9560546875 14257.56640625 6978.208984375 C 14257.6904296875 6978.50390625 14257.9853515625 6979.22607421875 14258.0205078125 6979.29833984375 C 14258.0576171875 6979.3740234375 14258.0810546875 6979.4599609375 14258.033203125 6979.556640625 C 14257.9853515625 6979.6552734375 14257.8193359375 6979.8671875 14257.666015625 6980.06103515625 C 14257.599609375 6980.14013671875 14257.5166015625 6980.212890625 14257.599609375 6980.36083984375 C 14257.6865234375 6980.5078125 14257.98046875 6980.98828125 14258.4189453125 6981.3779296875 C 14258.98046875 6981.87744140625 14259.453125 6982.03369140625 14259.6005859375 6982.1064453125 C 14259.6640625 6982.138671875 14259.716796875 6982.15478515625 14259.76171875 6982.15478515625 M 14258.828125 6969.99951171875 C 14264.8017578125 6969.99951171875 14269.6611328125 6974.857421875 14269.6611328125 6980.8291015625 C 14269.6611328125 6986.80224609375 14264.8017578125 6991.66162109375 14258.828125 6991.66162109375 C 14252.857421875 6991.66162109375 14247.9990234375 6986.80224609375 14247.9990234375 6980.8291015625 C 14247.9990234375 6974.857421875 14252.857421875 6969.99951171875 14258.828125 6969.99951171875 Z"
                stroke="none"
                fill="#ed1c24"
              />
            </g>
          </g>
        </svg>
      );
      break;
    }
    case 'envelope': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.89 21.89">
          <g id="mas" transform="translate(0.5 0.5)">
            <path
              id="Path_1276"
              data-name="Path 1276"
              d="M10.445,0A10.445,10.445,0,1,1,0,10.445,10.445,10.445,0,0,1,10.445,0Z"
              fill="none"
              stroke="#ed1c24"
              strokeWidth="1"
            />
            <path
              id="Icon_material-mail-outline"
              data-name="Icon material-mail-outline"
              d="M13.735,6H4.193A1.144,1.144,0,0,0,3.006,7.092L3,13.642a1.149,1.149,0,0,0,1.193,1.092h9.542a1.149,1.149,0,0,0,1.193-1.092V7.092A1.149,1.149,0,0,0,13.735,6Zm0,7.642H4.193V8.183l4.771,2.729,4.771-2.729ZM8.964,9.821,4.193,7.092h9.542Z"
              transform="translate(2)"
              fill="#ed1c24"
            />
          </g>
        </svg>
      );
      break;
    }
    case 'facebook':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26.346 26.236">
          <g id="_002-facebook-circular-logo" data-name="002-facebook-circular-logo" transform="translate(0 -0.055)">
            <path
              id="Path"
              d="M13.173,0a13.166,13.166,0,0,0-2.2,26.148V15.921H7.8v-3.68h3.178V9.527c0-3.149,1.923-4.865,4.732-4.865a26.225,26.225,0,0,1,2.837.144V8.1H16.6c-1.527,0-1.822.726-1.822,1.791v2.349H18.42l-.475,3.68H14.776V26.236A13.167,13.167,0,0,0,13.173,0Z"
              transform="translate(0 0.055)"
              fill={secondaryColor}
            />
          </g>
        </svg>
      );
      break;

    case 'instagram':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26.4 26.4">
          <g id="Group_53" data-name="Group 53" transform="translate(-61.6 -222)">
            <g id="_006-instagram" fill={secondaryColor} data-name="006-instagram" transform="translate(61.6 222)">
              <path
                id="Path"
                d="M5.053,2.527A2.527,2.527,0,1,1,2.527,0,2.527,2.527,0,0,1,5.053,2.527Z"
                transform="translate(10.673 10.673)"
              />
              <path
                id="Shape"
                d="M3.151,12.384a4.217,4.217,0,0,1-1.408-.261,2.345,2.345,0,0,1-.871-.567,2.348,2.348,0,0,1-.567-.872A4.205,4.205,0,0,1,.044,9.277C.008,8.478,0,8.238,0,6.214S.008,3.95.044,3.151A4.217,4.217,0,0,1,.305,1.743,2.356,2.356,0,0,1,.872.872,2.348,2.348,0,0,1,1.744.305,4.205,4.205,0,0,1,3.151.044C3.95.008,4.19,0,6.214,0S8.478.008,9.277.044a4.205,4.205,0,0,1,1.407.261,2.348,2.348,0,0,1,.872.567,2.352,2.352,0,0,1,.567.871,4.217,4.217,0,0,1,.261,1.408c.036.8.044,1.039.044,3.064s-.008,2.264-.044,3.063a4.205,4.205,0,0,1-.261,1.407,2.513,2.513,0,0,1-1.439,1.439,4.205,4.205,0,0,1-1.407.261c-.8.036-1.04.044-3.064.044S3.95,12.42,3.151,12.384Z"
                transform="translate(6.986 6.986)"
              />
              <path id="Shape-2" data-name="Shape" d="M0,13.2A13.2,13.2,0,1,1,13.2,26.4,13.2,13.2,0,0,1,0,13.2Z" />
            </g>
            <path
              id="Icon_awesome-instagram"
              data-name="Icon awesome-instagram"
              d="M7.01,5.654a3.6,3.6,0,1,0,3.6,3.6A3.59,3.59,0,0,0,7.01,5.654Zm0,5.933A2.338,2.338,0,1,1,9.348,9.25,2.342,2.342,0,0,1,7.01,11.587Zm4.581-6.08a.839.839,0,1,1-.839-.839A.837.837,0,0,1,11.591,5.507Zm2.381.851A4.15,4.15,0,0,0,12.84,3.42,4.178,4.178,0,0,0,9.9,2.287c-1.158-.066-4.628-.066-5.786,0a4.172,4.172,0,0,0-2.938,1.13A4.164,4.164,0,0,0,.044,6.355c-.066,1.158-.066,4.628,0,5.786A4.15,4.15,0,0,0,1.177,15.08a4.183,4.183,0,0,0,2.938,1.133c1.158.066,4.628.066,5.786,0A4.15,4.15,0,0,0,12.84,15.08a4.178,4.178,0,0,0,1.133-2.938c.066-1.158.066-4.625,0-5.783Zm-1.5,7.025a2.367,2.367,0,0,1-1.333,1.333A15.456,15.456,0,0,1,7.01,15a15.576,15.576,0,0,1-4.134-.282,2.367,2.367,0,0,1-1.333-1.333A15.456,15.456,0,0,1,1.261,9.25a15.576,15.576,0,0,1,.282-4.134A2.367,2.367,0,0,1,2.876,3.783,15.456,15.456,0,0,1,7.01,3.5a15.576,15.576,0,0,1,4.134.282,2.367,2.367,0,0,1,1.333,1.333,15.456,15.456,0,0,1,.282,4.134A15.447,15.447,0,0,1,12.477,13.384Z"
              transform="translate(67.791 225.922)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    case 'tikTok':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26">
          <g id="Group_54" data-name="Group 54" transform="translate(-107 -222)">
            <circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="13"
              cy="13"
              r="13"
              fill={secondaryColor}
              transform="translate(107 222)"
            />
            <path
              id="Icon_simple-tiktok"
              data-name="Icon simple-tiktok"
              d="M8.912.012C9.695,0,10.471.006,11.248,0a3.722,3.722,0,0,0,1.046,2.492,4.214,4.214,0,0,0,2.533,1.07V5.969a6.4,6.4,0,0,1-2.51-.58,7.382,7.382,0,0,1-.968-.556c-.006,1.745.006,3.489-.012,5.228a4.564,4.564,0,0,1-.807,2.354A4.452,4.452,0,0,1,7,14.334a4.357,4.357,0,0,1-2.438-.615,4.506,4.506,0,0,1-2.181-3.412c-.012-.3-.018-.6-.006-.89A4.5,4.5,0,0,1,7.591,5.425c.012.884-.024,1.769-.024,2.653A2.05,2.05,0,0,0,4.95,9.345a2.37,2.37,0,0,0-.084.962,2.034,2.034,0,0,0,2.091,1.715,2.007,2.007,0,0,0,1.655-.962,1.379,1.379,0,0,0,.245-.633c.06-1.07.036-2.133.042-3.2.006-2.408-.006-4.81.012-7.212Z"
              transform="translate(111.999 228.004)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;
    case 'blackDownArrow': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13.748 7.86">
          <path
            id="black_down_arrow"
            d="M13.064,16.737l5.2-5.2a.978.978,0,0,1,1.388,0,.991.991,0,0,1,0,1.392l-5.89,5.894a.981.981,0,0,1-1.355.029L6.474,12.931a.983.983,0,1,1,1.388-1.392Z"
            transform="translate(-6.188 -11.246)"
          />
        </svg>
      );
      break;
    }

    case 'upStageArrow': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 57 57">
          <g id="up_page" transform="translate(-1655 -1628)">
            <circle
              id="Ellipse_9"
              data-name="Ellipse 9"
              cx="28.5"
              cy="28.5"
              r="28.5"
              transform="translate(1655 1628)"
              fill="#fff"
            />
            <path
              id="Icon_ionic-ios-arrow-down"
              data-name="Icon ionic-ios-arrow-down"
              d="M16.191,14.694l7.562,7.568a1.423,1.423,0,0,0,2.019,0,1.441,1.441,0,0,0,0-2.025L17.2,11.663a1.427,1.427,0,0,0-1.971-.042L6.6,20.231a1.429,1.429,0,0,0,2.019,2.025Z"
              transform="translate(1667.313 1638.318)"
              fill="#ed1c24"
            />
          </g>
        </svg>
      );
      break;
    }
    case 'search':
      icon = (
        <svg {...svgProps} width={width} height={height} viewBox="0 0 27.9 27.9">
          <g id="search" transform="translate(0 0)">
            <path
              id="Shape"
              d="M26.667,27.9h0l-9.455-9.455a10.486,10.486,0,1,1,1.233-1.233L27.9,26.667,26.668,27.9ZM10.463,1.744a8.719,8.719,0,1,0,8.719,8.718A8.728,8.728,0,0,0,10.463,1.744Z"
              transform="translate(0 0)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    case 'locationMarker': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="11.1" height="14.8" viewBox="0 0 11.1 14.8">
          <path
            id="Icon_awesome-map-marker-alt"
            data-name="Icon awesome-map-marker-alt"
            d="M4.98,14.5C.78,8.413,0,7.788,0,5.55a5.55,5.55,0,0,1,11.1,0c0,2.238-.78,2.863-4.98,8.951a.694.694,0,0,1-1.141,0Zm.57-6.639A2.313,2.313,0,1,0,3.238,5.55,2.313,2.313,0,0,0,5.55,7.863Z"
            fill="#615858"
          />
        </svg>
      );
      break;
    }
    case 'star':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30">
          <g id="star" transform="translate(-1535 -600)">
            <circle
              id="star-2"
              data-name="star"
              cx="15"
              cy="15"
              r="15"
              transform="translate(1535 600)"
              fill="#ed1c24"
            />
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M9.836.625,7.54,5.279,2.4,6.028a1.125,1.125,0,0,0-.622,1.919L5.5,11.568l-.879,5.115A1.124,1.124,0,0,0,6.25,17.867l4.594-2.415,4.594,2.415a1.125,1.125,0,0,0,1.631-1.185l-.879-5.115,3.716-3.621a1.125,1.125,0,0,0-.622-1.919l-5.136-.749L11.853.625A1.126,1.126,0,0,0,9.836.625Z"
              transform="translate(1539.155 605.001)"
              fill="#fff"
            />
          </g>
        </svg>
      );
      break;
    case 'closePopUp':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="27.552" height="27.552" viewBox="0 0 27.552 27.552">
          <path
            id="Path_21"
            data-name="Path 21"
            d="M3.165-9.8h8.919v1.685H3.165V.764H1.48V-8.114H-7.4V-9.8H1.48v-8.919H3.165Z"
            transform="translate(5.771 18.468) rotate(45)"
            fill="#fff"
          />
        </svg>
      );
      break;
    case 'deleteFile':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.097" height="15.097" viewBox="0 0 15.097 15.097">
          <path
            id="Path_1311"
            data-name="Path 1311"
            d="M4.283,10.437V6.25H0V4.156H4.283V0H6.63V4.156h4.283V6.25H6.63v4.188Z"
            transform="translate(7.38) rotate(45)"
          />
        </svg>
      );
      break;
    case 'smile':
      icon = (
        <svg id="smile" xmlns="http://www.w3.org/2000/svg" width="28.38" height="28.38" viewBox="0 0 28.38 28.38">
          <path
            id="Path_1302"
            data-name="Path 1302"
            d="M15.315,1.125a14.19,14.19,0,1,0,14.19,14.19A14.19,14.19,0,0,0,15.315,1.125Zm8.7,22.886A12.254,12.254,0,1,1,26.647,20.1a12.254,12.254,0,0,1-2.636,3.909Z"
            transform="translate(-1.125 -1.125)"
          />
          <path
            id="Path_1303"
            data-name="Path 1303"
            d="M10.688,14.063h2.365v2.365H10.688Z"
            transform="translate(-2.647 -3.183)"
          />
          <path
            id="Path_1304"
            data-name="Path 1304"
            d="M22.5,14.063h2.365v2.365H22.5Z"
            transform="translate(-4.526 -3.183)"
          />
          <path
            id="Path_1305"
            data-name="Path 1305"
            d="M21.545,21.564a4.943,4.943,0,0,1-4.611,3.122h-.509a4.943,4.943,0,0,1-4.611-3.121l-.076-.189H9.7l.357.891a6.858,6.858,0,0,0,6.368,4.312h.509A6.858,6.858,0,0,0,23.3,22.267l.357-.892H21.621Z"
            transform="translate(-2.489 -4.347)"
          />
        </svg>
      );
      break;
    case 'plus':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="10.913" height="10.437" viewBox="0 0 10.913 10.437">
          <path id="plus" d="M4.283,10.437V6.25H0V4.156H4.283V0H6.63V4.156h4.283V6.25H6.63v4.188Z" />
        </svg>
      );
      break;

    default:
      break;
  }

  return (
    <i className={classNames(css.icon, className)} {...iconProps} onClick={onClick}>
      {icon}
    </i>
  );
};

Icon.defaultProps = {
  className: '',
  width: 38.945,
  height: 38.948,
  color: '#111',
  secondaryColor: '#000',
  onClick: () => null,
};

export default Icon;
